import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useSEO from "@/hooks/useSEO";
import { expos, COMPANY } from "@/data/clientsData";
import { ExpoCard } from "@/components/ClientGrid";
import { organizationSchema, breadcrumbSchema, itemListSchema } from "@/lib/seo-schemas";

const ProjectsPage = () => {
  useSEO({
    title: "Our Projects · Exhibition Stall & Expo Booth Portfolio | Stagehook Global",
    description:
      "Browse Stagehook Global's portfolio of exhibition stalls and expo booths built worldwide — Salone del Mobile, Interzoo, MWC Barcelona, AAPEX Las Vegas, SMM Hamburg, Prodexpo Moscow and more.",
    keywords:
      "exhibition stall portfolio, expo booth gallery, trade fair stand design, custom booth builder portfolio, exhibition stand examples",
    path: "/projects",
    jsonLd: [
      organizationSchema(),
      breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Projects", path: "/projects" },
      ]),
      itemListSchema(
        "All Expos",
        expos.map((e) => ({ name: `${e.name} — ${e.city}`, path: `/expo/${e.slug}` }))
      ),
    ],
  });

  return (
    <main data-testid="projects-page" className="pt-[72px]">
      <section className="py-24 grain relative">
        <div className="hero-blob" style={{ top: "-100px", right: "-200px", opacity: 0.2 }} />
        <div className="shg-container relative z-10">
          <div className="max-w-3xl">
            <div className="shg-eyebrow mb-5">Our Portfolio</div>
            <h1 className="font-display text-6xl md:text-7xl leading-[0.95] mb-6">
              Every expo.<br />
              Every <span style={{ color: "var(--red)" }}>stand</span>.
            </h1>
            <p className="text-lg text-[var(--text-soft)] max-w-xl">
              {expos.length} expos across {COMPANY.countriesServed} countries. Click into any expo to see the brands we&apos;ve built stands for.
            </p>
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="shg-container">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {expos.map((e) => (
              <ExpoCard key={e.slug} expo={e} />
            ))}
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="shg-container">
          <div
            className="rounded-2xl p-10 md:p-14 flex flex-col md:flex-row md:items-center justify-between gap-6"
            style={{ background: "var(--surface)", border: "1px solid var(--line-strong)" }}
          >
            <div>
              <div className="shg-eyebrow mb-3">Don&apos;t see your expo?</div>
              <h3 className="font-display text-3xl md:text-4xl">
                We build at <span style={{ color: "var(--red)" }}>any expo, anywhere.</span>
              </h3>
            </div>
            <Link to="/contact" className="btn-primary self-start">
              Ask us <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProjectsPage;
